module.exports = __webpack_public_path__ + "static/media/04_plantilla_combo_rectangular_marco_comida_22.2e1d93e2.png";